import AxiosRegisMorpromt from './axios_regis_morpromt'

const ModuleRegisMorpromt = {
  state: {
    stateGetOTP: [],
    stateConfirmOTP: [],
    stateFindTaxID: [],
    stateGetOTPV2: [],
    stateConfirmOTPV2: [],
    stateGetOTPV4: [],
    stateConfirmLoginOTP: [],
    stateSentOTPLoginV2: [],
    stateRegisterNexGenID: [],
    stateLoginNexGenID: [],
    stateCheckPhoneUser: [],
    stateEditPIN: [],
    stateGetOTPNexGenID: [],
    stateGetNexGenOTP: [],
    stateConfirmNexGenOTP: [],
    stateRegisterNexGenIDCard: [],
    stateGetNexGenOTPRePIN: [],
    stateConfirmNexGenOTPRePIN: []
  },
  mutations: {
    mutationsGetOTP (state, data) {
      state.stateGetOTP = data
    },
    mutationsConfirmOTP (state, data) {
      state.stateConfirmOTP = data
    },
    mutationsFindTaxID (state, data) {
      state.stateFindTaxID = data
    },
    mutationsGetOTPV2 (state, data) {
      state.stateGetOTPV2 = data
    },
    mutationsConfirmOTPV2 (state, data) {
      state.stateConfirmOTPV2 = data
    },
    mutationsGetOTPV4 (state, data) {
      state.stateGetOTPV4 = data
    },
    mutationsConfirmLoginOTP (state, data) {
      state.stateConfirmLoginOTP = data
    },
    mutationsSentOTPLoginV2 (state, data) {
      state.stateSentOTPLoginV2 = data
    },
    mutationsRegisterNexGenID (state, data) {
      state.stateRegisterNexGenID = data
    },
    mutationsLoginNexGenID (state, data) {
      state.stateLoginNexGenID = data
    },
    mutationsCheckPhoneUser (state, data) {
      state.stateCheckPhoneUser = data
    },
    mutationsEditPIN (state, data) {
      state.stateEditPIN = data
    },
    mutationsGetOTPNexGenID (state, data) {
      state.stateGetOTPNexGenID = data
    },
    mutationsGetNexGenOTP (state, data) {
      state.stateGetNexGenOTP = data
    },
    mutationsConfirmNexGenOTP (state, data) {
      state.stateConfirmNexGenOTP = data
    },
    mutationsRegisterNexGenIDCard (state, data) {
      state.stateRegisterNexGenIDCard = data
    },
    mutationsGetNexGenOTPRePIN (state, data) {
      state.stateGetNexGenOTPRePIN = data
    },
    mutationsConfirmNexGenOTPRePIN (state, data) {
      state.stateConfirmNexGenOTPRePIN = data
    }
  },
  actions: {
    async actionsGetOTP (context, access) {
      const getOTP = await AxiosRegisMorpromt.GetOTP(access)
      await context.commit('mutationsGetOTP', getOTP)
    },
    async actionsConfirmOTP (context, access) {
      const confirmOTP = await AxiosRegisMorpromt.ConfirmOTP(access)
      await context.commit('mutationsConfirmOTP', confirmOTP)
    },
    async actionsFindTaxID (context, access) {
      const findTaxID = await AxiosRegisMorpromt.FindTaxID(access)
      await context.commit('mutationsFindTaxID', findTaxID)
    },
    async actionsGetOTPV2 (context, access) {
      const getOTPV2 = await AxiosRegisMorpromt.GetOTPV2(access)
      await context.commit('mutationsGetOTPV2', getOTPV2)
    },
    async actionsConfirmOTPV2 (context, access) {
      const confirmOTPV2 = await AxiosRegisMorpromt.ConfirmOTPV2(access)
      await context.commit('mutationsConfirmOTPV2', confirmOTPV2)
    },
    async actionsGetOTPV4 (context, access) {
      const GetOTPV4 = await AxiosRegisMorpromt.GetOTPV4(access)
      await context.commit('mutationsGetOTPV4', GetOTPV4)
    },
    async actionsConfirmLoginOTP (context, access) {
      const ConfirmLoginOTP = await AxiosRegisMorpromt.ConfirmLoginOTP(access)
      await context.commit('mutationsConfirmLoginOTP', ConfirmLoginOTP)
    },
    async actionsSentOTPLoginV2 (context, access) {
      const ConfirmLoginOTP = await AxiosRegisMorpromt.SentOTPLoginV2(access)
      await context.commit('mutationsSentOTPLoginV2', ConfirmLoginOTP)
    },
    async actionsRegisterNexGenID (context, access) {
      const ConfirmLoginOTP = await AxiosRegisMorpromt.RegisterNexGenID(access)
      await context.commit('mutationsRegisterNexGenID', ConfirmLoginOTP)
    },
    async actionsLoginNexGenID (context, access) {
      const ConfirmLoginOTP = await AxiosRegisMorpromt.LoginNexGenID(access)
      await context.commit('mutationsLoginNexGenID', ConfirmLoginOTP)
    },
    async actionsCheckPhoneUser (context, access) {
      const ConfirmLoginOTP = await AxiosRegisMorpromt.CheckPhoneUser(access)
      await context.commit('mutationsCheckPhoneUser', ConfirmLoginOTP)
    },
    async actionsEditPIN (context, access) {
      const ConfirmLoginOTP = await AxiosRegisMorpromt.EditPIN(access)
      await context.commit('mutationsEditPIN', ConfirmLoginOTP)
    },
    async actionsGetOTPNexGenID (context, access) {
      const ConfirmLoginOTP = await AxiosRegisMorpromt.GetOTPNexGenID(access)
      await context.commit('mutationsGetOTPNexGenID', ConfirmLoginOTP)
    },
    async actionsGetNexGenOTP (context, access) {
      const ConfirmLoginOTP = await AxiosRegisMorpromt.GetNexGenOTP(access)
      await context.commit('mutationsGetNexGenOTP', ConfirmLoginOTP)
    },
    async actionsConfirmNexGenOTP (context, access) {
      const ConfirmLoginOTP = await AxiosRegisMorpromt.ConfirmNexGenOTP(access)
      await context.commit('mutationsConfirmNexGenOTP', ConfirmLoginOTP)
    },
    async actionsRegisterNexGenIDCard (context, access) {
      const ConfirmLoginOTP = await AxiosRegisMorpromt.RegisterNexGenIDCard(access)
      await context.commit('mutationsRegisterNexGenIDCard', ConfirmLoginOTP)
    },
    async actionsGetNexGenOTPRePIN (context, access) {
      const ConfirmLoginOTP = await AxiosRegisMorpromt.GetNexGenOTPRePIN(access)
      await context.commit('mutationsGetNexGenOTPRePIN', ConfirmLoginOTP)
    },
    async actionsConfirmNexGenOTPRePIN (context, access) {
      const ConfirmLoginOTP = await AxiosRegisMorpromt.ConfirmNexGenOTPRePIN(access)
      await context.commit('mutationsConfirmNexGenOTPRePIN', ConfirmLoginOTP)
    }
  }
}

export default ModuleRegisMorpromt
